
<!-- Footer -->
<!--<button style="display: none;position: fixed;right: 15px;background-color: #113983 !important;bottom: 46px;font-weight: 600;border: 1px solid #fff !important;"
        class="btn btn-primary btn-icon "
        type="button"
        (click)="csugges(cmod)"
        rippleEffect>
    Görüş - Öneri Bildir
</button>-->
<div (click)="csugges(cmod)" class="quest">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" height="32px" width="32px" role="img"
        alt="Sohbet simgesi" class="tawk-min-chat-icon">
        <path fill-rule="evenodd" clip-rule="evenodd" style="fill: white"
            d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z">
        </path>
    </svg>
</div>

<!--
<img src="assets/kultur/infocolors.png " (click)="csugges(cmod)"
     style="display: none;cursor:pointer; position: fixed;right: 36px;background-color: #ffffffeb !important;
     bottom: 46px;font-weight: 600;width: 50px;border-radius: 50%;border: 1px solid #fff !important;"/>-->
<div class="footer-1 d-inline-block w-100">
    <div class="container">
        <div class="" style="color: #fff;display: flex;flex-direction: column;width: 100%;align-items: center;">
            <div class="flex-column flex-sm-row" style="display: flex;">
                <div class="col-12 col-md-6 mt-3 mt-md-0 align-self-center text-center-mobile "
                    style="text-align: right">
                    <img src="assets/images/logo/kmlogobeyaz.png" width="250px" alt="Logo">
                </div>
                <div class="col-12 col-md-6 mt-3 mt-md-0  align-self-center text-center-mobile"
                    style="text-align: left;">
                    <img style="width: 310px;margin-top: 19px;background-color: #fff;padding: 5px;border-radius: 6px;"
                        alt="Logo" src="assets/images/logo/km-kultur-logo.png" width="250px">
                </div>
            </div>
            <div>
                <div
                    style="display: flex;justify-content: center;align-items: center;margin-top: 10px;margin-bottom: 10px;">
                    <span [data-feather]="'mail'" [size]="'1.5rem'" style="color:#fff;"></span>
                    <a style="margin-left: 10px;color:#fff;">{{website}}</a>
                </div>

                <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px; ">

                    <span [data-feather]="'phone'" [size]="'1.5rem'" style="color:#fff"></span>
                    <a style="margin-left: 10px;color:#fff;">(0 344) 225 24 15 - 225 24 16</a>

                </div>


                <div
                    style="display: flex;align-items: center;width: 100%;margin-bottom:7px;text-align: center;justify-content: center;flex-direction: row;">
                    <a target="_blank" rel="nofollow" href="https://x.com/KulturEnvKMBB"
                        style="cursor: pointer ;margin-right: 7px;">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="2.3rem" height="2.3rem"
                            viewBox="0 0 50 50">
                            <path
                                d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z">
                            </path>
                        </svg>
                    </a>
                    <a target="_blank" rel="nofollow" href="https://www.instagram.com/kmdijitalkulturenvanteri"
                        style="cursor: pointer ; margin-right: 4px;">
                        <svg width="1.7rem" height="1.7rem" viewBox="0 0 48 48" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
                                fill="#fff" />
                            <path
                                d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
                                fill="#fff" />
                            <path
                                d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
                                fill="#fff" />
                        </svg>
                    </a>
                    <img (click)="opentab('https://play.google.com/store/apps/details?id=com.kulturenvanter')"
                        style="cursor: pointer ;width: 30px !important;" src="assets/images/android-os.png"
                        alt="Android">
                    <img (click)="opentab('https://apps.apple.com/al/app/dijital-kültür-envanteri/id1628356243')"
                        style="cursor: pointer ;width: 30px!important;" src="assets/images/app-store.png"
                        alt="App Store">

                </div>

            </div>
            <div style="display: flex;flex-direction: column;margin-bottom: 6px;align-items: center;">
                <label
                    style="color: #fff; cursor: pointer;text-decoration: underline;text-transform: uppercase;width: 100%;text-align: center;font-weight: 600; margin-bottom: 1px;"
                    *ngFor="let item of linkss" (click)="goPage(item)"> {{item.name}} </label>
            </div>
            <div style="display: flex;flex-direction: column;margin-bottom: 6px;align-items: center;">
                <a routerLink="bloglar"
                    style="color: #fff; cursor: pointer;text-decoration: underline;text-transform: uppercase;width: 100%;text-align: center;font-weight: 600; margin-bottom: 1px;">
                    BlOGLAR </a>
            </div>
            <div class="">
                <span>
                    <span> {{ year }} Tüm Hakklar Saklıdır. &copy; | </span>
                    <a rel="nofollow" href="https://heyteknoloji.com/" target="_blank" style="color: white;"><b>Hey
                            Teknoloji</b></a>
                    <span> tarafından geliştirildi</span>
                </span>
            </div>
        </div>
    </div>
</div>

<ng-template #cmod let-cmod>
    <div class="contact-wrap w-100 p-md-5 p-4">
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <h3 class="mb-4">Görüş Öneri ve Şikayetler</h3>
            <label (click)="closeModal(cmod)"
                style="font-size: 19px;font-weight: 600;border: 1px solid lightgray;margin: 0px;border-radius: 7px;padding: 0px 10px 2px 10px;margin-bottom: 1.5rem;background-color: #eeeeee;">x</label>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="label">İsim Soyisim</label>
                    <input type="text" [(ngModel)]="sugges.isim" class="form-control" name="name" id="name"
                        placeholder="İsim Soyisim">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="label">Email Adresi</label>
                    <input type="email" [(ngModel)]="sugges.email" class="form-control" name="email" id="email"
                        placeholder="Email">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label class="label">Konu</label>
                    <input type="text" [(ngModel)]="sugges.konu" class="form-control" name="subject" id="subject"
                        placeholder="Konu">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label class="label">Detay</label>
                    <textarea name="message" [(ngModel)]="sugges.description" class="form-control" id="message"
                        cols="30" rows="4" placeholder="Açıklama"></textarea>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label
                        style="background-color: #0a275c;padding: 7px 14px;border-radius: 6px;color: #fff;float: right;"
                        (click)="save(cmod)">Gönder</label>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!--/ Footer -->

<!-- Move to top Button-->
<!--<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>-->